module.exports = __webpack_public_path__ + "img/background-middle.3511835b.jpg";